import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.web3earn.cc';

const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - attach JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const login = (username, password) =>
  api.post('/api/admin/login', { username, password });

export const getAdminInfo = () =>
  api.get('/api/admin/info');

export const updateProfile = (data) =>
  api.put('/api/admin/profile', data);

// Blacklist APIs
export const getBlacklist = (params) =>
  api.get('/api/admin/blacklist', { params });

export const addBlacklist = (data) =>
  api.post('/api/admin/blacklist', data);

export const deleteBlacklist = (id) =>
  api.delete(`/api/admin/blacklist/${id}`);

// Logs APIs
export const getLogs = (params) =>
  api.get('/api/admin/logs', { params });

export const getLogsStats = () =>
  api.get('/api/admin/logs/stats');

// File mappings APIs
export const getFiles = (params) =>
  api.get('/api/admin/files', { params });

export const addFile = (data) =>
  api.post('/api/admin/files', data);

export const updateFile = (id, data) =>
  api.put(`/api/admin/files/${id}`, data);

export const deleteFile = (id) =>
  api.delete(`/api/admin/files/${id}`);

// Settings APIs
export const getSettings = () =>
  api.get('/api/admin/settings');

export const updateSettings = (data) =>
  api.put('/api/admin/settings', data);

// Block Rules APIs (multi-dimensional)
export const getBlockRules = (params) =>
  api.get('/api/admin/block-rules', { params });

export const addBlockRule = (data) =>
  api.post('/api/admin/block-rules', data);

export const updateBlockRule = (id, data) =>
  api.put(`/api/admin/block-rules/${id}`, data);

export const deleteBlockRule = (id) =>
  api.delete(`/api/admin/block-rules/${id}`);

export default api;
